<div class="card">
    <div class="card-header border-0" *ngIf="showHeader !== undefined && showHeader === true">
        <div class="p-fluid justify-content-between">
            <h3 *ngIf="source === 'wearable'" class="card-title">Fonte: "Smartwatch"</h3>
            <h3 *ngIf="source === 't-shirt'" class="card-title">Fonte: "Comftech T-Shirt"</h3>
            <h3 *ngIf="source === 'Checkme'" class="card-title">Fonte: "Viatom"</h3>
            <div class="to-right" style="width: 195px;">
                <p-dropdown [options]="opt" [(ngModel)]="selected" dropdownIcon="fas fa-chevron-down"
                    (ngModelChange)="dropdownChange($event)"></p-dropdown>
            </div>
        </div>
    </div>
    <div class="card-body">
        <div #chart></div>
    </div>
</div>